import React from "react";

const AuthWrapper = () => (WrappedComponent) => (componentProps) => {
  return (
    <section className="initial-screen login-screen bg-cover-center">
      <div className="initial-screen-left-col">
        <WrappedComponent {...componentProps} />
      </div>
      <div
        className="initial-screen-right-col bg-cover-center"
        style={{
          backgroundImage: "url(" + "./assets/images/bg2.png" + ")",
        }}
      >
        <img
          src="./assets/images/logo-white.png"
          className="initial-screen-logo"
          alt="logo"
        />
      </div>
    </section>
  );
};

export default AuthWrapper;
